'use client';

import Link from 'next/link';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@/primitives';

type Props = {
  open: boolean;
  onClose: () => void;
};

export default function MyHerdLinkingInfoDialog({ open, onClose }: Props) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Link your herd for My Herd</DialogTitle>
      <DialogContent>
        <Typography variant="bodymedium" sx={{ mb: 2 }}>
          My Herd filters search results to animals associated with your member
          identity for the society you are viewing.
        </Typography>
        <Typography variant="bodymedium" sx={{ mb: 2 }}>
          On Linked accounts you can add a member association manually. This
          does not require linking an Internet Solutions registry account.
        </Typography>
        <Typography
          variant="bodymedium"
          sx={{
            color: 'text.secondary',
          }}
        >
          Open <strong>My Herd</strong>, choose the society and your member
          record, then save.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1, flexWrap: 'wrap' }}>
        <Button variant="outlined" onClick={onClose}>
          Close
        </Button>
        <Button
          component={Link}
          href="/account#linked-accounts"
          variant="contained"
          onClick={onClose}
        >
          Go to Linked accounts
        </Button>
      </DialogActions>
    </Dialog>
  );
}
